global.adiInit = "64661";
global.adiRVO = false;
global.adiFunc = null;

(function (w) {
  if (('epos' in w) && ('leadFormHasSubmitted' in w.epos) && w.epos.leadFormHasSubmitted === true) return;

  var adiSrc = document.createElement("script");
  adiSrc.type = "text/javascript";
  adiSrc.async = true;
  adiSrc.src = ("https:" == document.location.protocol ? "https://static-ssl" : "http://static-cdn")
    + ".responsetap.com/static/scripts/rTapTrack.min.js";
  var s = document.getElementsByTagName("script")[0];
  s.parentNode.insertBefore(adiSrc, s);
  rTapPostReplacement();
})(window);

function rTapPostReplacement() {
  jQuery('a.rTapNumber').each(function () {
    var number = jQuery(this).text();
    number = number.replace(/[^+\-0-9]/ig, '').toLowerCase();
    jQuery(this).attr('href', 'tel:' + number);
  });

  $(document).on('click', 'a.rtapNoSwap', function (e) {
    let account = parseInt($(this).data('rtap'));

    if (account) {
      e.preventDefault();

      rTapClickToCall(account);
    }
  })
}
